import { useMemo } from 'react';

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@mesh.ai/rabbit';
import { LabelFieldWrapper } from 'screens/admin/Reviews/ReviewProcessV2Intent/components/LabelFieldWrapper';

import { EngagementQuestionType, useAddEngagementQuestion } from '../slice/AddEngagementQuestion.slice';

type Props = {
  handleQuestionChange: (value: Partial<EngagementQuestionType>) => void;
};

const ADD_COMMENT_OPTIONS = [
  { value: 'no', label: 'No' },
  { value: 'optional', label: 'Yes - Optional' },
  { value: 'mandatory', label: 'Yes - Mandatory' },
];

const CanAddCommentDropdown = ({ handleQuestionChange }: Props) => {
  const { enableFeedbackText, isTextRequired } = useAddEngagementQuestion();

  const isCommentEnabled = useMemo(() => {
    // if only enableFeedbackText is true, then comment is optional
    if (enableFeedbackText && !isTextRequired) return 'optional';
    // if both are true, then comment is mandatory
    if (enableFeedbackText && isTextRequired) return 'mandatory';
    // if both are false, then comment is disabled
    return 'no';
  }, [enableFeedbackText, isTextRequired]);

  return (
    <LabelFieldWrapper label="Employees can add comments to this response" gridTemplateColumns="380px 1fr" gridGap={0}>
      <Select
        value={isCommentEnabled}
        onValueChange={(value) =>
          handleQuestionChange({
            isTextRequired: value === 'mandatory',
            enableFeedbackText: value !== 'no',
          })
        }
      >
        <SelectTrigger style={{ width: '100%', textAlign: 'left' }}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent style={{ maxWidth: '100%' }}>
          <SelectGroup>
            {ADD_COMMENT_OPTIONS.map(({ value, label }) => (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </LabelFieldWrapper>
  );
};

export { CanAddCommentDropdown };
